import { n as e, t } from "./chunk-useConsent-DC8uStwk.js";
//#region src/lib/affirmPaymentTerms.ts
var n = (e, t, n) => {
	let r = t / 100 / 360 * 30, i = e * r / (1 - (1 + r) ** +-n);
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		roundingMode: "ceil",
		maximumFractionDigits: 0,
		trailingZeroDisplay: "stripIfInteger"
	}).format(i);
}, r = !1;
e(() => a(), () => i(), ["marketing", "analytics"], r);
var i = () => {
	window._affirm_config = void 0, window.affirm = void 0, document.querySelectorAll("affirm-messaging").forEach((e) => {
		e.reRender();
	});
}, a = (e) => {
	let t = window.__VENDORS__.affirm.publicApiKey;
	!window.__VENDORS__.affirm.enabled || !t || (window._affirm_config = {
		public_api_key: t,
		script: "https://cdn1.affirm.com/js/v2/affirm.js"
	}, (function(e, t, n, r, i, a, o) {
		var s, c = e[n] || {}, l = document.createElement(a), u = document.getElementsByTagName(a)[0], d = function(e, t, n) {
			return function() {
				e[t]._.push([n, arguments]);
			};
		};
		for (c[r] = d(c, r, "set"), s = c[r], c[i] = {}, c[i]._ = [], s._ = [], c[i][o] = d(c, i, o), i = 0, o = "set add save post open empty reset on off trigger ready setProduct".split(" "); i < o.length; i++) s[o[i]] = d(c, r, o[i]);
		for (i = 0, o = [
			"get",
			"token",
			"url",
			"items"
		]; i < o.length; i++) s[o[i]] = function() {};
		l.async = !0, l.src = t[a], u.parentNode.insertBefore(l, u), delete t[a], s(t), e[n] = c;
	})(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready"), affirm.ui.ready(function() {
		e && affirm.ui.openModal(e);
	}));
}, o = class extends HTMLElement {
	constructor() {
		super(), this.pageType = this.getAttribute("data-page-type"), this.amount = Number(this.getAttribute("data-amount")), this.dollars = this.getAttribute("data-dollars"), this.months = Number(this.getAttribute("data-months")), this.rate = 15;
	}
	connectedCallback() {
		this.initialState = this.innerHTML, this.render();
	}
	render() {
		this.monthlyPayment = this.querySelector("[data-monthly-payment]"), this.monthlyPayment.innerText = n(this.dollars, this.rate, this.months), this.setUpListeners();
	}
	reRender() {
		this.innerHTML = this.initialState, this.render();
	}
	setUpListeners() {
		this.modalTrigger = this.querySelector("[data-affirm-modal-trigger]"), this.modalTrigger.addEventListener("click", (e) => {
			e.preventDefault(), t(() => a({
				page_type: this.pageType,
				amount: this.amount
			}), null, ["marketing", "analytics"], !0, r), s();
		});
	}
};
window.customElements.get("affirm-messaging") || window.customElements.define("affirm-messaging", o);
var s = () => {
	document.querySelector("app-provider").dispatchEvent(new CustomEvent("modal-dialog::close", {
		bubbles: !0,
		composed: !0,
		detail: "cart-drawer-dialog"
	}));
};
document.addEventListener("click", (e) => {
	e.target.classList.contains("affirm-modal-trigger") && s();
});
//#endregion
